export enum DashboardType {
    column,
    quadrant
}